<template>
  <div id="map-container">
    <SvgMap />
    <div class="infobox" id="svgmap-infobox"></div>
  </div>
</template>

<script setup lang="ts">
/*
Note: it should be possible to calculate the global X,Y co-ordinates of this map from the geoMsgBox values
e.g. mapsvg:geoViewBox="-169.110266 83.600842 190.486279 -58.508473"  (left-lng top-lat right-lng bottom-lat)
Using these numbers it is possible to then use the latitdue/longitude co-ordinates of cities e.g. Oslo
and convert this to x, y co-ordinates that can then be used to place markers on top of the svg map.
*/

import { onMounted } from "vue";
import SvgMap from "./SvgMap.vue";

const props = defineProps<{
  countries?: Array<string>;
}>();

onMounted(() => {
  const infoBoxId = "svgmap-infobox";
  if (props.countries) {
    for (const country of props.countries) {
      const elem: HTMLElement | null = document.getElementById(
        country.substring(0, 2)
      );
      if (elem) {
        const title = elem.getAttribute("title");
        elem.classList.add("supplier");
        elem.onmouseenter = (e: MouseEvent) => {
          const infobox = document.getElementById(infoBoxId);
          if (infobox) {
            infobox.style.left = e.clientX + 10 + "px";
            infobox.style.top = e.clientY + 10 + "px";
            infobox.textContent = title;
            infobox.style.opacity = "1";
          }
        };
        elem.onmouseleave = (e: MouseEvent) => {
          const infobox = document.getElementById(infoBoxId);
          if (infobox) {
            infobox.style.opacity = "0";
          }
        };
      }
    }
  }
});
</script>

<style lang="scss">
#map-container {
  position: relative;

  svg {
    width: 100%;
    height: auto;
  }

  path {
    fill: var(--light-grey-1);
  }

  .supplier {
    fill: var(--tangerine);
  }

  .infobox {
    background-color: var(--light-grey-2);
    border-radius: 1px;
    padding: 10px;
    position: fixed;
    z-index: 1000;
  }
}
</style>
